import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
// import { Box, Button, Drawer } from '@mui/material';
import { Box, Drawer } from '@mui/material';
// import { makeStyles } from '@material-ui/styles';
// import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import useResponsive from './useResponsive';
import NavSection from './NavSection';
import navConfig from './NavConfig';
import { fetchGetApiData } from '../../redux/action';
import { AISLE_LIST_ALL, USER_MARKETPLACES_LIST } from '../../config/api';
import StoreSwitcher from '../components/StoreSwitcher';
import ProductSwitcher from '../components/ProductSwitcher';
import { AISLE_ACTIVE_STATUS } from '../../config/constants';
import AgencyLogo from '../growz/AgencyLogo';

const DRAWER_WIDTH = 220;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
  },
}));

// const useStyles = makeStyles(() => ({
//   adPrimaryButton: {
//     fontSize: '14px!important',
//     background: '#1e38ea!important',
//     fontWeight: '500!important',
//     padding: '10px 14px 10px 14px!important',
//     color: '#fff!important',
//     textTransform: 'capitalize!important',
//     textAlign: 'left',
//     boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
//     borderRadius: '8px!important',
//     width: '100%',
//     fontFamily: '"Inter", Roboto, sans-serif !important',
//     letterSpacing: '0!important',
//   },
//   adPrimaryButtonDisabled: {
//     backgroundColor: 'rgb(147 147 147 / 10%)!important',
//     color: '#989898!important',
//     fontSize: '14px!important',
//     fontWeight: '500!important',
//     padding: '10px 14px 10px 14px!important',
//     textTransform: 'capitalize!important',
//     textAlign: 'left',
//     boxShadow: '0px 1px 2px rgb(16 24 40 / 5%)',
//     borderRadius: '8px!important',
//     width: '100%',
//     fontFamily: '"Inter", Roboto, sans-serif !important',
//   },
// }));

Sidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function Sidebar() {
  const dispatch = useDispatch();
  // const classes = useStyles();
  const isDesktop = useResponsive('up', 'lg');
  // const history = useHistory();
  const { profile } = useSelector(({ auth }) => auth.store);
  const allAisles = useSelector(({ page }) => page.getAllAisles?.data || []);
  const allProfiles = useSelector(({ page }) => page.allProfiles?.data || {});

  const AisleStats = {
    runningAisles: [],
    pausedAisles: [],
    keywords: [],
    searchVolume: 0,
  };

  useEffect(() => {
    if (!allAisles) {
      dispatch(
        fetchGetApiData({
          url: AISLE_LIST_ALL,
          key: 'getAllAisles',
        }),
      );
    }
    if (!allProfiles) {
      dispatch(
        fetchGetApiData({
          url: USER_MARKETPLACES_LIST,
          key: 'allProfiles',
          backend: 'lar',
        }),
      );
    }
  }, []);

  if (allAisles) {
    allAisles.forEach((aisle) => {
      if (AISLE_ACTIVE_STATUS.includes(aisle.status)) {
        AisleStats.runningAisles.push(aisle);
      } else {
        AisleStats.pausedAisles.push(aisle);
      }

      AisleStats.keywords = [...AisleStats.keywords, ...aisle.selectedKeywords];
      aisle.selectedKeywords.forEach((keyword) => (AisleStats.searchVolume += Number(keyword?.searchVolume?.volume)));
    });
  }

  const renderContent = (
    <>
      <Box style={{ padding: '16px 20px 24px 16px', height: '72px' }}>
        <AgencyLogo />
      </Box>

      <Box style={{ padding: '10px 16px' }}>
        <StoreSwitcher realm="aisle" profile={profile} allProfiles={allProfiles} />
      </Box>

      {/* <Box style={{ padding: '20px 16px' }}>
        <div>
          {!profile && (
            <Button className={classes.adPrimaryButtonDisabled} disabled>
              <svg
                style={{ verticalAlign: 'middle', marginRight: '13px', color: '#989898!important' }}
                width="12"
                height="17"
                viewBox="0 0 12 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.67807 1L1 10H6.11027L5.54246 16L11.2205 7H6.11027L6.67807 1Z"
                  stroke="#989898"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Create Dominator
            </Button>
          )}
          {profile && (
            <Button className={classes.adPrimaryButton} onClick={() => history.push('/aisle/create')}>
              <svg
                style={{ verticalAlign: 'middle', marginRight: '11px' }}
                width="12"
                height="17"
                viewBox="0 0 12 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.67807 1L1 10H6.11027L5.54246 16L11.2205 7H6.11027L6.67807 1Z"
                  stroke="#F4EBFF"
                  strokeWidth="1.33333"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Create Dominator
            </Button>
          )}
        </div>
      </Box> */}

      <NavSection navConfig={navConfig} user={profile} />

      <Box sx={{ flexGrow: 1 }} />

      <div
        style={{
          position: 'fixed',
          bottom: '0',
          padding: '16px 16px 24px',
          left: '0',
          width: '220px',
          background: '#101828',
          borderTop: '1px solid #202d48',
        }}
      >
        <ProductSwitcher />
      </div>
    </>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          PaperProps={{
            sx: { width: DRAWER_WIDTH },
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              borderRightStyle: 'dashed',
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
